import type { ZodType } from 'zod';

import { icsApi } from './api';

interface ParamsBase {
  apiVersion?: 'si-backend' | 'ics-api';
  url: string;
  body?: object;
  contentType?: string;
}

interface ParamsWithSchema<T> {
  apiVersion?: 'si-backend' | 'ics-api';
  url: string;
  body?: object;
  contentType?: string;
  schema: ZodType<T>;
}

const emptyObject = {} as const;

export async function post<T>(params: ParamsWithSchema<T>): Promise<T>;
export async function post(params: ParamsBase): Promise<void>;
export async function post<T>({
  url,
  body = emptyObject,
  contentType = 'application/json',
  ...rest
}: ParamsBase | ParamsWithSchema<T>): Promise<T | void> {
  const axiosResponse = await icsApi.post(url, body, {
    headers: {
      'Content-Type': contentType,
    },
  });

  if ('schema' in rest) {
    const response = rest.schema.safeParse(axiosResponse.data);
    if (!response.success) {
      throw new Error(response.error.message);
    }

    return response.data;
  }

  return axiosResponse.data;
}
